import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { CardContext } from './context/CardContext';
import Button from '@mui/material/Button';

const order = () => {
    alert("Order SUCCESSFUL");
};

const Order = () => {

    const { shopping, dispatch, totalPrice, } = useContext(CardContext);
    const data = useContext(CardContext);
    console.log(data);

    return (
        <div className="">
            <div className="container-fluid">
                <div className="row">
                    <div className='col-12 max-auto mt-3 mb-3  text-center'>
                        <h1 className="heading2 mt-5">Shopping Cart </h1>
                        <hr className="w-25 m-auto" />
                    </div>
                </div>
            </div>
            <div className="cards container-fluid ">

                {
                    shopping.length > 0 ? (

                        shopping.map((product, index) => {
                            return <>


                                <div className="outer_box">
                                    <div className="card_box">
                                        <div className="card_left">
                                            <img className="card_img"
                                                src={product.src} alt="" />
                                        </div>
                                        <div className="card_right">
                                            <div className="card_top">
                                                <span>₹ {product.price * product.qty} </span>
                                                <div className="close text-warning" onClick={() => dispatch({ type: "DELETE", id: product._id, product })}>+</div>
                                            </div>
                                            <div className="card_middle">
                                                <h4 className="heading">{product.cardTitle}</h4>
                                            </div>
                                            <div className="card_end">
                                                <div className="size">
                                                    <span>Size: </span>
                                                    {product.cardText}
                                                </div>
                                                <div className="quantity">
                                                    <button className="minus" onClick={() => dispatch({ type: "DEC", id: product._id, product })}>-</button>
                                                    <span>{product.qty}</span>
                                                    <button className="plus" onClick={() => dispatch({ type: "INC", id: product._id, product })}>+</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </>;
                        })
                    ) : <>

                        <div class="container-fluid mt-100">
                            <div class="row">
                                <div class="col-md-12 col-lg-12 col-sm-12 col-12">
                                    <div class="card">
                                        <div class="card-header">
                                            <h5>Cart</h5>
                                        </div>
                                        <div class="card-body cart">
                                            <div class="col-sm-12 empty-cart-cls text-center"> <img src="https://i.imgur.com/dCdflKN.png" width="130" height="130" class="img-fluid mb-4 mr-3" alt="" />
                                                <h3><strong>Your Cart is Empty</strong></h3>
                                                <NavLink exact activeClassName="" className="nav-link" to="/">
                                                    <Button className=" py-2 pl-5 px-4" variant="contained" style={{ backgroundColor: "#28B463", color: "white" }} > Add Items</Button>
                                                </NavLink>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }

            </div>

            {
                shopping.length > 0 ?
                    (
                        <>
                            <div class="footer ">
                                <div class="footer_box border">
                                    <div class="footer_left">
                                        <span class="fw-bold">Total : </span>
                                        {totalPrice}
                                    </div>
                                </div>
                            </div>
                            <div class="order my-4">
                                <div className="order_box">
                                    <Button className="py-2 pl-5 pr-5  cart_buttons OrderNow " variant="contained" color="primary" onClick={order}>Order</Button>
                                </div>
                            </div></>

                    ) : ""
            }
        </div>
    );
};

export default Order;
